import React, { FunctionComponent } from "react";

import { Org, User } from "src/lib/graphql/types";
import { isUser } from "src/lib/globalTypes";
import UserProfileSidebar from "./UserProfileSidebar";
import OrgSubOrganizations from "./OrgSubOrganizations";

type ProfileSidebarProps = {
  entity: User | Org;
};

const ProfileSidebar: FunctionComponent<ProfileSidebarProps> = ({ entity }) => {
  return isUser(entity) ? (
    <UserProfileSidebar user={entity} />
  ) : (
    <OrgSubOrganizations org={entity} />
  );
};

export default ProfileSidebar;
